import { render, staticRenderFns } from "./CardCompassYears.vue?vue&type=template&id=e4dd84de&scoped=true&"
import script from "./CardCompassYears.vue?vue&type=script&lang=js&"
export * from "./CardCompassYears.vue?vue&type=script&lang=js&"
import style0 from "./CardCompassYears.vue?vue&type=style&index=0&id=e4dd84de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dd84de",
  null
  
)

export default component.exports